import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from "src/environments/environment";
import { TerritoriesListItem, TerritoryVirtualLocationsDTO } from '../Models/TerritoriesListItem';
import { MapHelperService } from 'src/services/map-helper.service';
import { CloropetConfiguration } from 'src/models/CloropetClases';
import { MatDialog } from '@angular/material/dialog';
import { FeatureCollection } from '@turf/helpers';
import { TurfHelperService } from 'src/services/turf-helper.service';
import { PlaceLocationDetailsPopUpComponent } from '../../locations-section/components/3-panel-detail-locations/organisms/location-popup-details/place-location-detail-popup/place-location-details-popup.component';
import { EnumPolygonFillType } from '../../../ui/organisms/polygon-selector/helpers/enums/EnumPolygonFillType.enum';
@Injectable({
  providedIn: 'root'
})
export class TerritoriesLayerControlService {
  selectedLocations: { [key: string]: TerritoryVirtualLocationsDTO[] } = {};
  selectedLocations$: Subject<{ [key: string]: TerritoryVirtualLocationsDTO[] }> = new Subject<{ [key: string]: TerritoryVirtualLocationsDTO[] }>();

  territoryColors : { [key: string]: string } = {}
  filtroDeTerritorios: { [key: string]: { visiblePolygon: boolean, visibleLocations: boolean } } = {};
  $filtroDeTerritorios: BehaviorSubject<{ [key: string]: { visiblePolygon: boolean, visibleLocations: boolean } }> = new BehaviorSubject(this.filtroDeTerritorios);
  public filtroDeTerritorios$ = this.$filtroDeTerritorios.asObservable();

  territoryPolygonPropertyName = 'idTerritory';
  territoryLocationPropertyName = 'idTerritory';

  polygonSourcePrefix = 'territory-polygon-source';
  polygonLayerPrefix = 'territory-polygon-layer';
  polygonLayerTextPrefix = 'territory-polygon-text';

  polygonCentroidSourcePrefix = 'territory-centroid-source';
  polygonCentroidLayerPrefix = 'territory-centroid-layer';

  locationSourcePrefix = 'territory-location-source';
  locationLayerPrefix = 'territory-location-layer';

  detailsPopUp: any = null;
  hoveredMarker: any = null;
  hoveredMarkerFeature: any = null;

  constructor(private mapHelperService: MapHelperService, private dialog: MatDialog, private turfService: TurfHelperService) {

  }

  setSelectedLocations(territoryLocations: { [key: string]: TerritoryVirtualLocationsDTO[] }) {
    this.selectedLocations = territoryLocations;
    this.selectedLocations$.next(this.selectedLocations);
  }

  getSelectedLocations() {
    return this.selectedLocations$.asObservable();
  }
  
  initializeTerritorySourceAndLayers() {
    const cloropetConfigDummy: CloropetConfiguration = {
      propertyName: 'saturation',
      usePercentageRanges: true,
      clases: [
        { classProperty: 70, classValue: '#ff5858' },
        { classProperty: 30, classValue: '#FEB24C' },
        { classProperty: 0, classValue: '#7bff6f' },
      ]
    };

    this.createPolygonSourceAndLayers('all', EnumPolygonFillType.Solid, null, "Rutas de zona");
    this.createTerritoryLocationsSourceAndLayers('all', "Rutas de zona");
    this.createTerritoryCentroidSourceAndLayers('all', "Rutas de zona");
  }

  createPolygonSourceAndLayers(sourceNameAdd: string, fillType: string = EnumPolygonFillType.Cloropet, cloropetConfig: CloropetConfiguration = null, layerDisplayName: string, fillColor: string = '#627e90'): void {
    const polygonSourceName = this.polygonSourcePrefix + '-' + sourceNameAdd;
    const polygonLayerName = this.polygonLayerPrefix + '-' + sourceNameAdd;
    const polygonLayerLineName = 'line-' + this.polygonLayerPrefix + '-' + sourceNameAdd;
    const polygonLayerTextName = this.polygonLayerTextPrefix + '-' + sourceNameAdd;
    const lineColor = '#352F84';

    const existingSource = this.mapHelperService.GetSourceByName(polygonSourceName);
    if (!existingSource) {
      this.mapHelperService.AddSourceEmptyGeoJson(polygonSourceName, layerDisplayName, 'annotation-territories-cloropet-polygons.png');

      if (fillType == EnumPolygonFillType.Cloropet && cloropetConfig) {
        this.mapHelperService.AddLayerPolygonsForTerritoryStatus(polygonLayerName, polygonSourceName, "Poligonos de " + layerDisplayName);
        // this.mapHelperService.AddLayerPolygonsForTerritoryStatus(polygonLayerName, polygonSourceName, "Poligono de " + layerDisplayName, fillColor, cloropetConfig);
      } else {
        this.mapHelperService.AddLayerPolygonsForTerritoryStatus(polygonLayerName, polygonSourceName, "Poligonos de " + layerDisplayName);
        // this.mapHelperService.AddLayerPolygonsForTerritoryStatus(polygonLayerName, polygonSourceName, "Poligono de " + layerDisplayName, fillColor);
        // this.mapHelperService.AddLayerLine(polygonLayerLineName, polygonSourceName, "Líneas de " + layerDisplayName, lineColor, 3);
      }

      this.mapHelperService.AddLayerText(polygonLayerTextName, polygonSourceName, this.territoryPolygonPropertyName, "Etiqueta de " + layerDisplayName, -1);
    } else {
      console.log("ya existe el source simple");
    }
  }

  createTerritoryLocationsSourceAndLayers(sourceNameAdd: string, layerDisplayName: string): void {
    const locationSourceName = this.locationSourcePrefix + '-' + sourceNameAdd;
    const locationLayerName = this.locationLayerPrefix + '-' + sourceNameAdd;
    const locationActiveLayerName = this.locationLayerPrefix + '-' + sourceNameAdd + '-active';
    const locationLayerTextName = this.locationLayerPrefix + '-text-' + sourceNameAdd;

    const existingSource = this.mapHelperService.GetSourceByName(locationSourceName);

    if (!existingSource) {

      this.mapHelperService.AddSourceEmptyGeoJson(locationSourceName, "Ubicaciones/" + layerDisplayName, 'annotation-territories-locations.png', 'uniqueId');
      // this.mapHelperService.AddLayerCluster(locationLayerName + "-layerCluster", locationSourceName, "Clusters de Ubicaciones/" + layerDisplayName);
      // this.mapHelperService.AddLayerClusterCount(locationLayerName + "-layerClusterCount", locationSourceName, "Conteo de Clusters de Ubicaciones/" + layerDisplayName);
      this.mapHelperService.AddCirclesLayerWithHex(locationLayerName, locationSourceName, "Puntos de Ubicaciones/" + layerDisplayName);
      this.mapHelperService.AddLayerText(locationLayerTextName, locationSourceName, 'identifier', "Etiqueta de Ubicaciones/" + layerDisplayName, -1.5);
      
      // this.mapHelperService.AddSourceClusteredEmptyGeoJson(locationSourceName, "Ubicaciones/" + layerDisplayName);
      // this.mapHelperService.AddLayerCluster(locationLayerName + "-layerCluster", locationSourceName, "Clusters de Ubicaciones/" + layerDisplayName);
      // this.mapHelperService.AddLayerClusterCount(locationLayerName + "-layerClusterCount", locationSourceName, "Conteo de Clusters de Ubicaciones/" + layerDisplayName);
      // this.mapHelperService.AddLayerUnclusteredPointsV2(locationLayerName, locationSourceName, null, "Puntos de Ubicaciones/" + layerDisplayName, 0.0811);
      // this.mapHelperService.AddLayerText(locationLayerTextName, locationSourceName, 'identifier', "Etiqueta de Ubicaciones/" + layerDisplayName, -2);

      // this.mapHelperService.AddSourceEmptyGeoJson(locationSourceName + '-active', "Punto activo de Ubicaciones/" + layerDisplayName);
      // this.mapHelperService.AddLayerLocationsGeneral(locationActiveLayerName, locationSourceName + '-active', 'icon', "Punto activo de Ubicaciones/" + layerDisplayName, 0.0811);

      this.addEvent(sourceNameAdd);
    } else {
      console.log("ya existe el source simple");
    }
  }

  createTerritoryCentroidSourceAndLayers(sourceNameAdd: string, layerDisplayName: string): void {
    const centroidSourceName = this.polygonCentroidSourcePrefix + '-' + sourceNameAdd;
    const centroidLayerName = this.polygonCentroidLayerPrefix + '-' + sourceNameAdd;
    const centroidActiveLayerName = this.polygonCentroidLayerPrefix + '-' + sourceNameAdd + '-active';
    const centroidLayerTextName = this.polygonCentroidLayerPrefix + '-text-' + sourceNameAdd;

    const existingSource = this.mapHelperService.GetSourceByName(centroidSourceName);

    if (!existingSource) {

      this.mapHelperService.AddSourceClusteredEmptyGeoJson(centroidSourceName, "Puntos centrales/" + layerDisplayName, 'annotation-territories-locations.png');
      
      
      this.mapHelperService.AddLayerCluster(centroidLayerName + "-layerCluster" + "-layerCluster", centroidSourceName, "centros/" + layerDisplayName);
      this.mapHelperService.AddLayerClusterCount(centroidLayerName + "-layerClusterCount", centroidSourceName, "Conteo de Clusters de centros/" + layerDisplayName);
      this.mapHelperService.AddLayerLocationsGeneral(centroidLayerName, centroidSourceName, "icon", "Puntos centrales/" + layerDisplayName, 0.05);
      this.mapHelperService.AddLayerText(centroidLayerTextName, centroidSourceName, 'IdTerritory', "Etiqueta de puntos centrales/" + layerDisplayName, -2.5);

    } else {
      console.log("ya existe el source simple");
    }
  }

  loadCentroidGeoJson(sourceNameAdd: string, geoJson: any): void {
    const centroidSourceName = this.polygonCentroidSourcePrefix + '-' + sourceNameAdd;
    
    this.mapHelperService.UpdateLayerGeoJson(centroidSourceName, geoJson);
    this.mapHelperService.FitBounds(geoJson, 150);
  }

  resetCentroidsGeoJson(sourceNameAdd: string): void {
    const centroidSourceName = this.polygonCentroidSourcePrefix + '-' + sourceNameAdd;
    
    this.mapHelperService.UpdateLayerGeoJson(centroidSourceName, this.mapHelperService.Empty_GeoJson);
  }

  destroySourceAndLayers(sourceNameAdd: string = 'all'): void {
    const polygonSourceName = this.polygonSourcePrefix + '-' + sourceNameAdd;
    const locationSourceName = this.locationSourcePrefix + '-' + sourceNameAdd;
    const centroidSourceName = this.polygonCentroidSourcePrefix + '-' + sourceNameAdd;

    this.removeFilters();

    this.clearLocationsState(sourceNameAdd);

    this.mapHelperService.UpdateLayerGeoJson(polygonSourceName, this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.UpdateLayerGeoJson(locationSourceName, this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.UpdateLayerGeoJson(centroidSourceName, this.mapHelperService.Empty_GeoJson);

    this.filtroDeTerritorios = {};
    this.$filtroDeTerritorios.next(this.filtroDeTerritorios);

    this.selectedLocations = {};
    this.selectedLocations$.next(this.selectedLocations);
  }

  addActiveTerritoryPolygonFilter(territoryId: string) {
    const polygonLayerName = this.polygonLayerPrefix + '-all';
    const polygonLayerTextName = this.polygonLayerTextPrefix + '-all';
    this.filtroDeTerritorios[territoryId] = this.filtroDeTerritorios[territoryId] || { visiblePolygon: false, visibleLocations: false };
    this.filtroDeTerritorios[territoryId].visiblePolygon = true;
    this.mapHelperService.filterLayerByProperty(polygonLayerName, this.territoryPolygonPropertyName, Object.keys(this.filtroDeTerritorios).filter(id => this.filtroDeTerritorios[id].visiblePolygon));
    this.mapHelperService.filterLayerByProperty(polygonLayerTextName, this.territoryPolygonPropertyName, Object.keys(this.filtroDeTerritorios).filter(id => this.filtroDeTerritorios[id].visiblePolygon));
    this.$filtroDeTerritorios.next(this.filtroDeTerritorios);
  }

  removeActiveTerritoryPolygonFilter(territoryId: string) {
    const polygonLayerName = this.polygonLayerPrefix + '-all';
    const polygonLayerTextName = this.polygonLayerTextPrefix + '-all';
    this.filtroDeTerritorios[territoryId] = this.filtroDeTerritorios[territoryId] || { visiblePolygon: false, visibleLocations: false };
    this.filtroDeTerritorios[territoryId].visiblePolygon = false;
    this.mapHelperService.filterLayerByProperty(polygonLayerName, this.territoryPolygonPropertyName, Object.keys(this.filtroDeTerritorios).filter(id => this.filtroDeTerritorios[id].visiblePolygon));
    this.mapHelperService.filterLayerByProperty(polygonLayerTextName, this.territoryPolygonPropertyName, Object.keys(this.filtroDeTerritorios).filter(id => this.filtroDeTerritorios[id].visiblePolygon));
    this.$filtroDeTerritorios.next(this.filtroDeTerritorios);
  }

  addActiveTerritoryLocationFilter(territoryIdentifier: string) {
    const locationLayerName = this.locationLayerPrefix + '-all';
    const locationLayerTextName = this.locationLayerPrefix + '-text-all';
    this.filtroDeTerritorios[territoryIdentifier] = this.filtroDeTerritorios[territoryIdentifier] || { visiblePolygon: false, visibleLocations: false };
    this.filtroDeTerritorios[territoryIdentifier].visibleLocations = true;
    this.mapHelperService.filterLayerByProperty(locationLayerName, this.territoryLocationPropertyName, Object.keys(this.filtroDeTerritorios).filter(id => this.filtroDeTerritorios[id].visibleLocations));
    this.mapHelperService.filterLayerByProperty(locationLayerTextName, this.territoryLocationPropertyName, Object.keys(this.filtroDeTerritorios).filter(id => this.filtroDeTerritorios[id].visibleLocations));
    this.$filtroDeTerritorios.next(this.filtroDeTerritorios);
  }

  removeActiveTerritoryLocationFilter(territoryIdentifier: string) {
    const locationLayerName = this.locationLayerPrefix + '-all';
    const locationLayerTextName = this.locationLayerPrefix + '-text-all';
    this.filtroDeTerritorios[territoryIdentifier] = this.filtroDeTerritorios[territoryIdentifier] || { visiblePolygon: false, visibleLocations: false };
    this.filtroDeTerritorios[territoryIdentifier].visibleLocations = false;
    this.mapHelperService.filterLayerByProperty(locationLayerName, this.territoryLocationPropertyName, Object.keys(this.filtroDeTerritorios).filter(id => this.filtroDeTerritorios[id].visibleLocations));
    this.mapHelperService.filterLayerByProperty(locationLayerTextName, this.territoryLocationPropertyName, Object.keys(this.filtroDeTerritorios).filter(id => this.filtroDeTerritorios[id].visibleLocations));
    this.$filtroDeTerritorios.next(this.filtroDeTerritorios);
  }

  hideAllTerritoryLayers(){
    const polygonLayerName = this.polygonLayerPrefix + '-all';
    const polygonLayerTextName = this.polygonLayerTextPrefix + '-all';
    const locationLayerName = this.locationLayerPrefix + '-all';
    const locationLayerTextName = this.locationLayerPrefix + '-text-all';
    Object.keys(this.filtroDeTerritorios).forEach(territoryId => {
      this.filtroDeTerritorios[territoryId].visiblePolygon = false;
      this.filtroDeTerritorios[territoryId].visibleLocations = false;
    });
    this.mapHelperService.filterLayerByProperty(polygonLayerName, this.territoryPolygonPropertyName, []);
    this.mapHelperService.filterLayerByProperty(polygonLayerTextName, this.territoryPolygonPropertyName, []);
    this.mapHelperService.filterLayerByProperty(locationLayerName, this.territoryLocationPropertyName, []);
    this.mapHelperService.filterLayerByProperty(locationLayerTextName, this.territoryLocationPropertyName, []);
    this.$filtroDeTerritorios.next(this.filtroDeTerritorios);
  }

  removeFilters(){
    const polygonLayerName = this.polygonLayerPrefix + '-all';
    const polygonLayerTextName = this.polygonLayerTextPrefix + '-all';
    const locationLayerName = this.locationLayerPrefix + '-all';
    const locationLayerTextName = this.locationLayerPrefix + '-text-all';
    Object.keys(this.filtroDeTerritorios).forEach(territoryId => {
      this.filtroDeTerritorios[territoryId].visiblePolygon = false;
      this.filtroDeTerritorios[territoryId].visibleLocations = false;
    });
    this.mapHelperService.removeFilterLayer(polygonLayerName);
    this.mapHelperService.removeFilterLayer(polygonLayerTextName);
    this.mapHelperService.removeFilterLayer(locationLayerName);
    this.mapHelperService.removeFilterLayer(locationLayerTextName);
    this.$filtroDeTerritorios.next(this.filtroDeTerritorios);
  }

  openLocationPopup(identifier: any, parentCoordX: string, parentCoordY: string, sourceNameAdd: string) {
    const sourceName = this.locationSourcePrefix + '-' + sourceNameAdd;
    if (this.detailsPopUp) {
      this.detailsPopUp.close();
      this.detailsPopUp = null;
    }
    const popupData = {
      identifier: identifier,
      parentCoordX: parentCoordX,
      parentCoordY: parentCoordY,
      // activeSourceName: sourceName + '-active',
    };
    this.detailsPopUp = this.dialog.open(PlaceLocationDetailsPopUpComponent,
      {
        maxWidth: "98vw",
        maxHeight: "92vh",
        autoFocus: false,
        restoreFocus: false,
        hasBackdrop: false,
        disableClose: true,
        data: popupData,
      }
    );

  }

  loadMorePolygonGeoJson(sourceNameAdd: string, geoJson: any): void {
    const polygonSourceName = this.polygonSourcePrefix + '-' + sourceNameAdd;
    
    const source = this.mapHelperService.GetSourceByName(polygonSourceName);
    const geoJsonActual = source ? (source as any)._data : { type: "FeatureCollection", features: [] };
    
    const existingIdentifiers = new Set(
      geoJsonActual.features.map(f => f.properties?.idTerritory).filter(id => id !== undefined)
    );
    
    const newFeatures = geoJson.features.filter(
      f => !existingIdentifiers.has(f.properties?.idTerritory)
    );

    newFeatures.forEach(feature => {
      feature.id = feature.id ||feature.properties?.idTerritory;
    });
    
    const combinedGeoJson = {
      type: "FeatureCollection",
      features: [...geoJsonActual.features, ...newFeatures]
    };
    this.mapHelperService.UpdateLayerGeoJson(polygonSourceName, combinedGeoJson);
  }

  loadPolygonGeoJson(sourceNameAdd: string, geoJson: any): void {
    const polygonSourceName = this.polygonSourcePrefix + '-' + sourceNameAdd;
    const polygonLayerName = this.polygonLayerPrefix + '-' + sourceNameAdd;
    const polygonLayerTextName = this.polygonLayerTextPrefix + '-' + sourceNameAdd;
    
    this.mapHelperService.UpdateLayerGeoJson(polygonSourceName, geoJson);
    this.mapHelperService.FitBounds(geoJson, 150);

    //rearmo los filtros con los features que ha en el nuevo geoJson, para que se mantengan visibles aun si se crga de nuevo
    const filtroBackUp = { ...this.filtroDeTerritorios };
    this.filtroDeTerritorios = {};
    geoJson.features.forEach(feature => {
      this.filtroDeTerritorios[feature.properties[this.territoryPolygonPropertyName]] = filtroBackUp[feature.properties[this.territoryPolygonPropertyName]] || { visiblePolygon: true, visibleLocations: false };
      feature.id = feature.id || feature.properties?.idTerritory;
    });
    
    const visibleTerritories = Object.keys(this.filtroDeTerritorios).filter(id => this.filtroDeTerritorios[id].visiblePolygon);
    this.mapHelperService.filterLayerByProperty(polygonLayerName, this.territoryPolygonPropertyName, visibleTerritories);
    this.mapHelperService.filterLayerByProperty(polygonLayerTextName, this.territoryPolygonPropertyName, visibleTerritories);
    
    this.$filtroDeTerritorios.next(this.filtroDeTerritorios);
  }

  resetPolygonGeoJson(sourceNameAdd: string): void {
    const polygonSourceName = this.polygonSourcePrefix + '-' + sourceNameAdd;
    
    const source = this.mapHelperService.GetSourceByName(polygonSourceName);
    const geoJsonActual = source ? (source as any)._data : { type: "FeatureCollection", features: [] };
    
    const existingIdentifiers = new Set<string>(
      geoJsonActual.features.map(f => f.properties?.idTerritory).filter(id => id !== undefined)
    );
    
    existingIdentifiers.forEach(id => {
      this.filtroDeTerritorios[id] = this.filtroDeTerritorios[id] || { visiblePolygon: false, visibleLocations: false };
      this.filtroDeTerritorios[id].visiblePolygon = false;
    });
    this.mapHelperService.UpdateLayerGeoJson(polygonSourceName, this.mapHelperService.Empty_GeoJson);
  }

  resetLocationGeoJson(sourceNameAdd: string): void {
    const locationSourceName = this.locationSourcePrefix + '-' + sourceNameAdd;
    
    const source = this.mapHelperService.GetSourceByName(locationSourceName);
    const geoJsonActual = source ? (source as any)._data : { type: "FeatureCollection", features: [] };
    
    const existingIdentifiers = new Set<string>(
      geoJsonActual.features.map(f => f.properties?.idTerritory).filter(id => id !== undefined)
    );
    
    existingIdentifiers.forEach(id => {
      this.filtroDeTerritorios[id] = this.filtroDeTerritorios[id] || { visiblePolygon: false, visibleLocations: false };
      this.filtroDeTerritorios[id].visibleLocations = false;
    });
    this.mapHelperService.UpdateLayerGeoJson(locationSourceName, this.mapHelperService.Empty_GeoJson);
  }

  loadMoreLocationGeoJson(sourceNameAdd: string, geoJson: any): void {
    const locationSourceName = this.locationSourcePrefix + '-' + sourceNameAdd;
    
    const source = this.mapHelperService.GetSourceByName(locationSourceName);
    const geoJsonActual = source ? (source as any)._data : { type: "FeatureCollection", features: [] };
    
    const existingIdentifiers = new Set(
      geoJsonActual.features.map(f => f.properties?.identifier).filter(id => id !== undefined)
    );
    
    const newFeatures = geoJson.features.filter(
      f => !existingIdentifiers.has(f.properties?.identifier)
    );

    newFeatures.forEach(feature => {
      feature.id = feature.properties?.identifier;
      feature.properties.uniqueId = feature.properties?.identifier;
    });
    
    const combinedGeoJson = {
      type: "FeatureCollection",
      features: [...geoJsonActual.features, ...newFeatures]
    };
    
    
    // Actualizar el source con el geoJson combinado
    this.mapHelperService.UpdateLayerGeoJson(locationSourceName, combinedGeoJson);
    this.mapHelperService.FitBounds(combinedGeoJson, 150);
  }

  updateLocationGeoJsonPreservingStates(sourceNameAdd: string, newGeoJson: any): void {
    const locationSourceName = this.locationSourcePrefix + '-' + sourceNameAdd;
    
    newGeoJson.features.forEach(feature => {
      feature.id = feature.properties?.identifier;
      feature.properties.uniqueId = feature.properties?.identifier;
    });
    
    this.mapHelperService.UpdateLayerGeoJson(locationSourceName, newGeoJson);

    //actualiza los selected para que las ubicaciones se vayan a su nuevo territorio
    const newSelectedLocations: { [key: string]: TerritoryVirtualLocationsDTO[] } = {};
    for (const oldTerritoryId in this.selectedLocations) {
      for (const loc of this.selectedLocations[oldTerritoryId]) {
        const feature = newGeoJson.features.find(f => f.properties?.identifier === loc.identifier);
        if (feature) {
          const newTerritoryId = feature.properties.idTerritory;
          newSelectedLocations[newTerritoryId] = newSelectedLocations[newTerritoryId] || [];
          newSelectedLocations[newTerritoryId].push(loc);
        }
      }
    }
    this.selectedLocations = newSelectedLocations;
    this.selectedLocations$.next(this.selectedLocations);
  }

  assignColor(identifier: string){
    if(this.territoryColors[identifier]){
      return this.territoryColors[identifier];
    }else{
      const newColor = this.getRandomColor();
      this.territoryColors[identifier] = newColor;
      return newColor;
    }
  }

  getRandomColor(): string {
    return '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
  }

  createReorderedGeoJson(territoryLocations: { [key: string]: TerritoryVirtualLocationsDTO[] }): FeatureCollection {
    const reorderedGeoJson: FeatureCollection = {
      type: "FeatureCollection",
      features: []
    };
    Object.keys(territoryLocations).forEach(territoryId => {
      const locations = territoryLocations[territoryId];
      const coords = locations.map(loc => [Number(loc.cordsX), Number(loc.cordsY)]);
      
      if (coords.length > 2) {
        // Usa convex hull para obtener solo los puntos exteriores
        const convexHullFeature = this.turfService.GetConvexHull(coords);
        
        if (convexHullFeature) {
          convexHullFeature.properties = {
            idTerritory: territoryId,
            color: this.assignColor(territoryId)
          };
          reorderedGeoJson.features.push(convexHullFeature);
        }
      }
    });
    return reorderedGeoJson;
  }

  private orderPointsByAngle(coords: number[][]): number[][] {
    //en teoria ordena los puntos para que no se deforme el poligono, funciona ahorita, pero revisar a fondo
    const centroidX = coords.reduce((sum, coord) => sum + coord[0], 0) / coords.length;
    const centroidY = coords.reduce((sum, coord) => sum + coord[1], 0) / coords.length;
    
    return coords.slice().sort((a, b) => {
      const angleA = Math.atan2(a[1] - centroidY, a[0] - centroidX);
      const angleB = Math.atan2(b[1] - centroidY, b[0] - centroidX);
      return angleA - angleB;
    });
  }

  
  addEvent(sourceNameAdd: string) {
    const locationSourceName = this.locationSourcePrefix + '-' + sourceNameAdd;
    const locationLayerName = this.locationLayerPrefix + '-' + sourceNameAdd;

    const mouseClick = (e) => {
      if (e.features.length > 0) {
        const feature = e.features[0];
        const identifier = feature.properties ? feature.properties.identifier : '';
        const idTerritory = feature.properties ? feature.properties.idTerritory : '';

        this.selectedLocations[idTerritory] = this.selectedLocations[idTerritory] || [];

        this.selectedLocations[idTerritory] = this.selectedLocations[idTerritory] || [];

        const isSelected = !this.selectedLocations[idTerritory].some(loc => loc.identifier === identifier);
        
        this.mapHelperService._map.setFeatureState(
          { source: locationSourceName, id: feature.id },
          { selected: isSelected }
        );

        console.log("feature click", feature);
        
    
        if(isSelected) {
          const newLocation: TerritoryVirtualLocationsDTO = {
            identifier: identifier,
            cordsX: feature.geometry.type === 'Point' ? feature.geometry.coordinates[0].toString() : '',
            cordsY: feature.geometry.type === 'Point' ? feature.geometry.coordinates[1].toString() : '',
          } as TerritoryVirtualLocationsDTO;
          this.selectedLocations[idTerritory].push(newLocation);
        } else {
          this.selectedLocations[idTerritory] = this.selectedLocations[idTerritory].filter(loc => loc.identifier !== identifier);
        }
        
        this.selectedLocations$.next(this.selectedLocations);

      }

    };

    const layerMouseOver = (e) => {
      if (e.features.length > 0) {
        const feature = e.features[0];
        const marker = feature.properties;

        this.hoveredMarker = marker;
        this.hoveredMarkerFeature = feature;
        
        this.mapHelperService._map.getCanvas().style.cursor = 'pointer';
        
        this.mapHelperService._map.setFeatureState(
          { source: locationSourceName, id: feature.id },
          { hover: true }
        );
      }
    };

    const layerMouseLeave = () => {
      if (this.hoveredMarkerFeature) {
        if (!environment.production) console.log("hoveredMarkerId", this.hoveredMarker)
        
        this.mapHelperService._map.getCanvas().style.cursor = '';
        this.mapHelperService._map.setFeatureState(
          { source: locationSourceName, id: this.hoveredMarkerFeature.id },
          { hover: false }
        );

        this.hoveredMarker = null;
        this.hoveredMarkerFeature = null;
      }
    };

    this.mapHelperService._map.on('click', locationLayerName, mouseClick);
    this.mapHelperService._map.on('mouseenter', locationLayerName, layerMouseOver);
    this.mapHelperService._map.on('mouseleave', locationLayerName, layerMouseLeave);
  }

  clearLocationsState(sourceNameAdd: string, locationIdentifier: string = null): void {
    const locationSourceName = this.locationSourcePrefix + '-' + sourceNameAdd;
    const locationLayerName = this.locationLayerPrefix + '-' + sourceNameAdd;
    
    const layer = this.mapHelperService._map.getLayer(locationLayerName);
    if (!layer) {
      return;
    }
    
    const source = this.mapHelperService.GetSourceByName(locationSourceName);
    if (!source) {
      return;
    }

    const geoJsonActual = (source as any)._data;    
      
    if (locationIdentifier) {
      const feature = geoJsonActual.features.find(f => f.properties?.identifier === locationIdentifier);

      if (feature && feature.id) {
        this.mapHelperService._map.setFeatureState(
          { source: locationSourceName, id: feature.id },
          { selected: false }
        );
        
        const idTerritory = feature.properties?.idTerritory;
        if (idTerritory && this.selectedLocations[idTerritory]) {
          this.selectedLocations[idTerritory] = this.selectedLocations[idTerritory].filter(
            loc => loc.identifier !== locationIdentifier
          );
          if (this.selectedLocations[idTerritory].length === 0) {
            delete this.selectedLocations[idTerritory];
          }
          this.selectedLocations$.next(this.selectedLocations);
        }
      }
    } else {
      geoJsonActual.features.forEach(feature => {
        if (feature.id) {
          this.mapHelperService._map.setFeatureState(
            { source: locationSourceName, id: feature.id },
            { selected: false }
          );
        }
      });
      
      this.selectedLocations = {};
      this.selectedLocations$.next(this.selectedLocations);
    }
  }

  addLocationsToSelected(territoryLocations: { [key: string]: TerritoryVirtualLocationsDTO[] }) {
    const locationSourceName = this.locationSourcePrefix + '-all';

    const source = this.mapHelperService.GetSourceByName(locationSourceName);
    const geoJsonActual = source ? (source as any)._data : { type: "FeatureCollection", features: [] };

    if (!geoJsonActual.features || geoJsonActual.features.length === 0) {
      return;
    }

    const identifiersByTerritory: { [key: string]: Set<string> } = {};
    Object.keys(territoryLocations).forEach(territoryId => {
      identifiersByTerritory[territoryId] = new Set<string>(
        territoryLocations[territoryId].map(loc => loc.identifier)
      );
    });

    geoJsonActual.features.forEach(feature => {
      const featureIdentifier = feature.properties?.identifier;
      if (!featureIdentifier) return;

      // busca el territorio y si encuentra el identificador, se sale de la busqueda
      for (const territoryId in identifiersByTerritory) {
        if (identifiersByTerritory[territoryId].has(featureIdentifier)) {
          this.mapHelperService._map.setFeatureState(
            { source: locationSourceName, id: feature.id },
            { selected: true }
          );
          break;
        }
      }
    });

    Object.keys(territoryLocations).forEach(territoryId => {
      this.selectedLocations[territoryId] = this.selectedLocations[territoryId] || [];
      
      // Crear Set de identifiers ya seleccionados para evitar duplicados
      const existingIdentifiers = new Set<string>( this.selectedLocations[territoryId].map(loc => loc.identifier) );
      
      // Solo agregar las que no existen
      const newLocations = territoryLocations[territoryId].filter( loc => !existingIdentifiers.has(loc.identifier) );
      
      this.selectedLocations[territoryId].push(...newLocations);
    });
    
    this.selectedLocations$.next(this.selectedLocations);
  }

  closeDetailPopUp(){
    if (this.detailsPopUp) {
      this.detailsPopUp.close();
      this.detailsPopUp = null;
    }
  }



  //--------------------- deprecados de momento /////////

  // initializePanelTerritoryLayers() {
  //   const cloropetConfigDummy: CloropetConfiguration = {
  //     propertyName: 'saturation',
  //     usePercentageRanges: true,
  //     clases: [
  //       { classProperty: 70, classValue: '#ff5858' },
  //       { classProperty: 30, classValue: '#FEB24C' },
  //       { classProperty: 0, classValue: '#7bff6f' },
  //     ]
  //   };

  //   this.createPolygonSourceAndLayers('panel', EnumPolygonFillType.Cloropet, cloropetConfigDummy, "Rutas de zona filtrados");
  //   // this.createTerritoryLocationsSourceAndLayers('panel', "Rutas de zona filtrados");
  // }

  // toggleTerritoryLayers(isVisible: boolean, sourceNameAdd: string = 'panel'): void {
  //   const polygonSourceName = this.polygonSourcePrefix + '-' + sourceNameAdd;

  //   if (!isVisible){
  //     this.mapHelperService.HideLayersBySource(polygonSourceName);
  //   }else{
  //     this.mapHelperService.ShowLayersBySource(polygonSourceName);
  //   }
  // }

  // destroyPanelTerritoryLayers(sourceNameAdd: string = 'panel'): void {
  //   const polygonSourceName = this.polygonSourcePrefix + '-' + sourceNameAdd;

  //   this.mapHelperService.UpdateLayerGeoJson(polygonSourceName, this.mapHelperService.Empty_GeoJson);
  // }

  // initializeDetailTerritoryLayers() {
  //   const cloropetConfigDummy: CloropetConfiguration = {
  //     propertyName: 'saturation',
  //     usePercentageRanges: true, 
  //     clases: [
  //       { classProperty: 70, classValue: '#ff5858' },
  //       { classProperty: 30, classValue: '#FEB24C' },
  //       { classProperty: 0, classValue: '#7bff6f' },
  //     ]
  //   };

  //   this.createPolygonSourceAndLayers('detail', EnumPolygonFillType.Cloropet, cloropetConfigDummy, "Territorio seleccionado");
  //   this.createTerritoryLocationsSourceAndLayers('detail', "Territorio seleccionado");
  // }

  // destroyDetailTerritoryLayers(sourceNameAdd: string = 'detail'): void {
  //   const polygonSourceName = this.polygonSourcePrefix + '-' + sourceNameAdd;
  //   const locationSourceName = this.locationSourcePrefix + '-' + sourceNameAdd;

  //   this.mapHelperService.UpdateLayerGeoJson(polygonSourceName, this.mapHelperService.Empty_GeoJson);
  //   this.mapHelperService.UpdateLayerGeoJson(locationSourceName, this.mapHelperService.Empty_GeoJson);
  //   this.mapHelperService.UpdateLayerGeoJson(locationSourceName + '-active', this.mapHelperService.Empty_GeoJson);

  //   if (this.detailsPopUp) {
  //     this.detailsPopUp.close();
  //     this.detailsPopUp = null;
  //   }
  // }


  // createTerritoryLocationsSourceAndLayers(sourceNameAdd: string, layerDisplayName: string): void {
  //   const locationSourceName = this.locationSourcePrefix + '-' + sourceNameAdd;
  //   const locationLayerName = this.locationLayerPrefix + '-' + sourceNameAdd;
  //   const locationActiveLayerName = this.locationLayerPrefix + '-' + sourceNameAdd + '-active';
  //   const locationLayerTextName = this.locationLayerPrefix + '-text-' + sourceNameAdd;

  //   const existingSource = this.mapHelperService.GetSourceByName(locationSourceName);

  //   if (!existingSource) {
  //     // this.mapHelperService.AddSourceEmptyGeoJson(sourceName, "Ubicaciones/agebs");
  //     // this.mapHelperService.AddLayerLocationsGeneral(layerName, sourceName, 'icon', "Ubicaciones/agebs", 0.1011);
  //     // this.mapHelperService.AddLayerText(layerTextName, sourceName, 'description', "Etiqueta de Ubicaciones/agebs", -3);

  //     this.mapHelperService.AddSourceClusteredEmptyGeoJson(locationSourceName, "Ubicaciones/" + layerDisplayName);
  //     this.mapHelperService.AddLayerCluster(locationLayerName + "-layerCluster", locationSourceName, "Clusters de Ubicaciones/" + layerDisplayName);
  //     this.mapHelperService.AddLayerClusterCount(locationLayerName + "-layerClusterCount", locationSourceName, "Conteo de Clusters de Ubicaciones/" + layerDisplayName);
  //     this.mapHelperService.AddLayerUnclusteredPointsV2(locationLayerName, locationSourceName, null, "Puntos de Ubicaciones/" + layerDisplayName, 0.0811);
  //     this.mapHelperService.AddLayerText(locationLayerTextName, locationSourceName, 'identifier', "Etiqueta de Ubicaciones/" + layerDisplayName, -2);

  //     this.mapHelperService.AddSourceEmptyGeoJson(locationSourceName + '-active', "Punto activo de Ubicaciones/" + layerDisplayName);
  //     this.mapHelperService.AddLayerLocationsGeneral(locationActiveLayerName, locationSourceName + '-active', 'icon', "Punto activo de Ubicaciones/" + layerDisplayName, 0.0811);

  //     this.addEvent(sourceNameAdd);
  //   } else {
  //     console.log("ya existe el source simple");
  //   }
  // }
}
